import { render, staticRenderFns } from "./submission.page.vue?vue&type=template&id=c3e5d1de&scoped=true&"
import script from "./submission.page.vue?vue&type=script&lang=js&"
export * from "./submission.page.vue?vue&type=script&lang=js&"
import style0 from "./submission.page.vue?vue&type=style&index=0&id=c3e5d1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e5d1de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
